import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Menu, Globe, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom'

export default function Header() {
  return (
    <nav className=" container-fluid navbar navbar-expand-lg bg-white shadow-sm position-relative">
      <div className="container d-flex align-items-center justify-content-between">
        {/* Left icons: language selector and chat */}
        <div className="d-flex align-items-center">
          <button type="button" className="btn btn-link text-dark p-0 me-3" aria-label="Language">
            <img
              src="https://flagcdn.com/w20/fr.png"
              srcSet="https://flagcdn.com/w40/fr.png 2x"
              alt="Français"
              width="24"
              height="18"
              className="rounded"
            />
          </button>
          <Link to="/contact" className="btn btn-link text-dark p-0" aria-label="Chat">
            <MessageCircle size={24} />
          </Link>
        </div>

        {/* Center logo - absolutely centered */}
        <a
          className="navbar-brand position-sticky s text-center"
          href="/"
          style={{ whiteSpace: 'nowrap' }}
        >
          <img
            src="/image.png"
            alt="Logo"
            height="30"
            className="d-inline-block align-middle"
          />
          <span className="text-secondary d-inline-block align-middle ms-1" style={{ fontSize: '10px' }}>
            Verification
          </span>
        </a>

        {/* Hamburger toggle (Bootstrap collapse) */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <Menu size={24} />
        </button>

        {/* Collapsible menu links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.recharge.fr"
                data-bs-toggle=""
                data-bs-target=""
                target='_blank'
              >
                Acheter
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.recharge.com/fr/fr/mobile-top-up"
                data-bs-toggle=""
                data-bs-target=""
                target='_blank'
              >
                Recharge mobile
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.recharge.com/fr/fr/gaming-cards"
                data-bs-toggle=""
                data-bs-target=""
                target='_blank'
              >
                Jeux videos
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}